import { render, staticRenderFns } from "./AddStore.vue?vue&type=template&id=a1653a84&"
import script from "./AddStore.vue?vue&type=script&lang=js&"
export * from "./AddStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports